'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'tree';
var width = 512;
var height = 512;
var aliases = [127794];
var unicode = 'f1bb';
var svgPathData = 'M268.3-26.5l146.7 169.9 22.9 26.5-81.1 0 89.2 104.9 22.4 26.4-93.8 0 102.3 120.4 22.4 26.4-227.2 0 0 96-32 0 0-96-227.2 0 22.4-26.4 102.3-120.4-93.8 0 22.4-26.4 89.2-104.9-81.1 0 22.8-26.5 146.8-169.9 12.1-14 12.1 14zM144.3 137.9l80.4 0-22.4 26.3-89.2 105 93.9 0-22.4 26.3-102.3 120.4 347.9 0-102.3-120.4-22.4-26.3 93.9 0-89.2-105-22.4-26.3 80.3 0-111.8-129.5-111.8 129.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTree = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;